import React from "react";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
// import './MaestroDateRangePicker.scss';
import { DateRangePicker } from 'react-date-range';

import {
    endOfDay,
    startOfMonth,
    endOfMonth,
    isSameDay,
    subDays,
    startOfYear,
    endOfYear,
    startOfQuarter,
    endOfQuarter,
} from 'date-fns';

const defineds = {
    endOfToday: endOfDay(new Date()),
    startOfMonth: startOfMonth(new Date()),
    endOfMonth: endOfMonth(new Date()),

    startOfQuarter: startOfQuarter(new Date()),
    endOfQuarter: endOfQuarter(new Date()),

    startOfYear: startOfYear(new Date()),
    endOfYear: endOfYear(new Date()),
};

const staticRangeHandler = {
    range: {},
    isSelected(range) {
      const definedRange = this.range();
      return (
        isSameDay(range.startDate, definedRange.startDate) &&
        isSameDay(range.endDate, definedRange.endDate)
      );
    },
};

export function createStaticRanges(ranges) {
    return ranges.map(range => ({ ...staticRangeHandler, ...range }));
}

const defaultStaticRanges = createStaticRanges([
    {
      label: 'All Time',
      range: () => ({
        startDate: new Date(1900, 0, 1),
        endDate: defineds.endOfToday,
      }),
    },
    {
      label: 'This Year',
      range: () => ({
        startDate: defineds.startOfYear,
        endDate: defineds.endOfYear,
      }),
    },

    {
      label: 'This Quarter',
      range: () => ({
        startDate: defineds.startOfQuarter,
        endDate: defineds.endOfQuarter,
      }),
    },
    {
      label: 'This Month',
      range: () => ({
        startDate: defineds.startOfMonth,
        endDate: defineds.endOfMonth,
      }),
    },
]);

// this is the default range to display
const selectionRange = {
    startDate: subDays(new Date(), 7),
    endDate: new Date(),
    key: 'selection',
};

const MaestroDateRangePicker = (props) => {
    return (
        <DateRangePicker
            // ranges={[selectionRange]}
            inputRanges={[]}
            staticRanges={defaultStaticRanges}
            {...props}
        />
    );
}

export default MaestroDateRangePicker;


//   staticRanges: defaultStaticRanges,
